export class Country {
  id: number;

  countryName: string;

  countryCode: string;

  static parse(data: any): Country {
    return Object.assign(new Country(), {
      id: data.id,
      countryName: data.countryName,
      countryCode: data.countryCode
    });
  }
}
